import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { Card } from 'src/components'
import { IDataForm } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloForm'
import {
  EPayFile,
  EPayType,
  getFilesByType,
} from 'src/content/CardProviders/CardProvider/Forms/Pagalo/utils/TypePagaloBusiness'
import { FileUploader } from 'src/components/inputs/FileUploader'

export const PagaloFiles = ({ data, setData }: IDataForm) => {
  const fileTypes = getFilesByType(data.typeBusiness?.value as EPayType)

  const toBase64 = (file: File): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {
        const base64String = (reader.result as string).split(',')[1]
        resolve(base64String)
      }
      reader.onerror = error => reject(error)
    })

  const onFileSelect = async (type: EPayFile, file: File) => {
    const files = [...(data?.files ?? [])].filter(f => f.code !== type.code)

    if (file) {
      files.push({
        code: type.code,
        file: await toBase64(file),
      })
    }

    setData(prev => ({ ...prev, files }))
  }

  return (
    <Card white title={'Archivos'}>
      <Row>
        {fileTypes.map(fileType => (
          <Col
            key={fileType.code}
            xl={6}
            lg={6}
            md={6}
            sm={12}
            xs={12}
            className={'mb-3'}>
            <FileUploader
              acceptedTypes={['pdf', 'png', 'jpeg']}
              maxFileSizeMB={3}
              onFileSelect={file => onFileSelect(fileType, file)}
              label={fileType.name}
              description={fileType.information}
            />
          </Col>
        ))}
      </Row>
    </Card>
  )
}
